// NPM Imports
import React, { useContext } from 'react'
// Quote Context
import { useQuoteContext } from '../../../hooks/useQuoteContext'
// Component Imports
// JS Imports
import { formatFloatAsCurrencySymbol } from '../../../common/helpers.mjs'
// Asset Imports

export default function TotalMonthlyRow() {
   const state = useQuoteContext()
   const { getString } = state

   if (state.user_view == 'Internal' || state.monthlyTotal.totalPrice > 0)
      return (
         <div className='row grey-bold'>
            <div className='col-bhr1 col-bhr5'>
               <span>{getString('global.MonthlyTotal')}</span>
            </div>
            <div className='col'>
               {(state.product_list[state.coreProductSelected]?.[
                  'MinimumEmployees'
               ] > state.productCoreEECount &&
                  state.productCoreEECount > 0) ||
               (state.product_list['payroll']?.['MinimumEmployees'] >
                  state.productPayrollTotalEECount &&
                  state.productPayrollTotalEECount > 0) ||
               (state.product_list['benAdmin']?.['MinimumEmployees'] >
                  state.productBenefitsAdministrationEECount &&
                  state.productBenefitsAdministrationEECount > 0) ? (
                  ''
               ) : (
                  <span>
                     {formatFloatAsCurrencySymbol(
                        state.monthlyTotal.discountedPEPMCost,
                        state.currencyObject,
                     )}
                  </span>
               )}
            </div>
            <div className='col'></div>
            <div className='col'>
               <span>
                  {formatFloatAsCurrencySymbol(
                     state.monthlyTotal.totalPrice,
                     state.currencyObject,
                  )}
               </span>
            </div>
         </div>
      )
}
